<template>
  <div v-loading="loading">
    <el-card class="mat12">
      <div class="table_box post_name_table_box" style="height: 400px;">
        <div class="table_wrap">
          <div class="table_head">
            <div class="table-th">岗位名称</div>
            <div class="table-th" style="width:200px;flex-shrink: 0;">
              岗位位置
            </div>
            <div class="table-th">
              值岗类型
            </div>
            <div class="table-th" v-if="currentType !== '派遣单'" style="width: 90px; flex-shrink: 0">
              每日工作时长
            </div>
            <div class="table-th">上班时间</div>
            <div class="table-th">合同人数</div>
            <div class="table-th">岗位补助</div>
            <div class="table-th">岗位配置</div>
            <div class="table-th">人员配置</div>
            <div class="table-th">创建时间</div>
            <!-- <div
              class="table-th"
              v-if="currentType !== '派遣单'"
              style="width: 90px; flex-shrink: 0"
            >
              删除岗位名称
            </div> -->
            <div class="table-th" v-if="currentType !== '派遣单'">删除时间</div>

            <div class="table-th" v-if="currentType !== '派遣单'" style="width:200px;flex-shrink: 0;">地图位置</div>
            <div class="table-th" v-if="currentType !== '派遣单'">打卡二维码</div>





            <div class="table-th" style="min-width: 200px" v-if="currentType !== '派遣单'">
              <span class="table-text">应勤工时</span>
              <el-date-picker class="card_table-picker mal20" v-model="value" type="month" placeholder="选择月"
                @change="handleDateValue" format="yyyy-MM" value-format="yyyy-MM" :clearable="false"></el-date-picker>
            </div>
          </div>
          <div v-for="(item, index) in data" :key="index">
            <div :class="item.isTotal ? 'table_tbody not_bottom' : 'table_tbody'">
              <!-- 岗位名称 -->
              <div :class="item.isTotal ? 'table-tb font_word' : 'table-tb'">
                <span :class="item.delState == 1 ?'grey':''"> {{ item.postName }}</span>
              </div>
              <!-- 岗位位置 -->
              <div class="table-tb" style="width:200px;flex-shrink: 0;" v-if="!item.isTotal">
                <span :class="item.delState == 1 ?'grey':''"> {{ item.position ? item.position : "未填写" }}</span>
              </div>
              <div v-else class="table-tb" style="width:200px;flex-shrink: 0;"></div>
              <!-- 值岗类型 -->
              <div class="table-tb" v-if="!item.isTotal">
                <span :class="item.delState == 1 ?'grey':''"> {{ getPostType(item.postType) }}</span>
              </div>
              <div v-else class="table-tb"></div>
              <!-- 每日工作时长 -->
              <div class="table-tb" v-if="!item.isTotal && currentType !== '派遣单'" style="width: 90px; flex-shrink: 0">
                <span :class="item.delState == 1 ?'grey':''">{{ item.workingHours ? item.workingHours : "0" }}小时</span>
              </div>
              <!-- 每日工作时长 -->
              <div v-if="item.isTotal && currentType !== '派遣单'" class="table-tb"></div>
              <!-- 上班时间 -->
              <div class="table-tb"> <span :class="item.delState == 1 ?'grey':''">{{ item.officeHours }}</span></div>
              <!-- 合同人数 -->
              <div :class="item.isTotal ? 'table-tb footer_gs' : 'table-tb'">
                <span :class="item.delState == 1 ?'grey':''">{{ item.num ? item.num : "0" }}人</span>
              </div>
              <!-- 岗位补助 -->
              <div class="table-tb" v-if="!item.isTotal">
                <span :class="item.delState == 1 ?'grey':''">{{ item.postSubsidy ? item.postSubsidy : "0" }}元</span>
              </div>
              <div class="table-tb" v-else></div>

              <!-- 岗位配置 -->
              <div class="table-tb">
                <span :class="item.delState == 1 ?'grey':''">{{ item.ppc.workType | filterWorkType }}</span>
                <span v-if="item.ppc.workType == 1" class="red">（{{ item.ppc.restDaysOfMonth }} 天）</span>
              </div>

              <!-- 人员配置 -->
              <div class="table-tb">
                <span :class="item.delState == 1 ?'grey':''">{{ item.ppc.staffType | filterWorkType }}</span>
                <span v-if="item.ppc.staffType == 1" class="red">（{{ item.ppc.staffDaysOfMonth }} 天）</span>
              </div>


              <!-- 创建时间 -->
              <div :class="item.isTotal ? 'table-tb font_word' : 'table-tb'">
                <span :class="item.delState == 1 ?'grey':''">{{ item.createDate }}</span>
              </div>
              <!-- 删除岗位名称 -->
              <!-- <div
                :class="item.isTotal ? 'table-tb font_word' : 'table-tb'"
                v-if="currentType !== '派遣单'"
                style="width: 90px; flex-shrink: 0"
              >
                {{ item.update }}
              </div> -->
              <!-- 删除时间 -->
              <div :class="item.isTotal ? 'table-tb font_word' : 'table-tb'" v-if="currentType !== '派遣单'">
                <span
                  :class="item.delState == 1 ?'grey':''">{{ item.delState == 1 ?(item.updateDate?item.updateDate.substr(0,10):''):'' }}</span>
              </div>

              <!-- 地图位置 -->
              <div :class="item.isTotal ? 'table-tb font_word' : 'table-tb'" v-if="currentType !== '派遣单'"
                style="width:200px;flex-shrink: 0;">
                <el-popover placement="top" width="150" trigger="hover">
                  {{ item.site?item.site:'' }}
                  <span
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;width: 200px;display: inline-block;cursor: pointer;"
                    slot="reference" @click="tableMap(item)" :class="item.delState == 1 ?'grey':''"><i v-if="item.site"
                      class="el-icon-map-location"
                      style="color:#409EFF ;display: inline-block;margin-right: 3px;"></i>{{ item.site?item.site:'' }}</span>
                </el-popover>
              </div>
              <!-- 打卡二维码 -->
              <div :class="item.isTotal ? 'table-tb font_word' : 'table-tb'" v-if="currentType !== '派遣单'">
                <el-popover placement="top" width="150" trigger="hover">
                  <el-image style="width: 150px; height: 150px" :src="envhref+item.qrCode" fit="contain"></el-image>
                  <el-button plain icon="el-icon-download" style="width: 150px;margin: 7px 0 20px" size="small"
                    @click='downs(item.qrCode)' type="primary">
                    下载二维码
                  </el-button>
                  <el-image v-if="item.qrCode" style="width: 30px; height: 30px" :src="envhref+item.qrCode"
                    slot="reference" fit="contain"></el-image>
                </el-popover>
              </div>





              <!-- 应勤工时 -->
              <div class="table-tb" :class="item.isTotal ? 'table-tb footer_gs' : 'table-tb'" style="min-width: 200px"
                v-if="currentType !== '派遣单'">
                <span :class="item.delState == 1 ?'grey':''">{{ item.postTotalHours ? item.postTotalHours : 0 }} /
                  时</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <el-dialog title="地图位置" :visible.sync="isTableMap" @closed="mapClose" @open="mapOpen" :close-on-click-modal="false"
      width='500px' class="tableMap">

      <div style="margin: 6px 0 10px;">
        标记岗位位置：{{dutyd.site==''?'（请点击地图坐标点选择岗位位置）':dutyd.site}}
      </div>
      <baidu-map :style="{width:map.width,height:map.height}" class="bm-view" :ak="Ak" :scroll-wheel-zoom="true"
        :center="{lng: dutyd.baiduLng, lat: dutyd.baiduLat}" :zoom="zoom" @ready="handler">
        <bm-view style="width: 100%; height:265px;"></bm-view>
        <bm-marker title='1234' :position="{lng: dutyd.baiduLng, lat: dutyd.baiduLat}">
          <bm-label v-if='dutyd.position!=""' :content="'岗位位置：'+dutyd.position"
            :labelStyle="{padding:'5px',border:'#000',borderRadius:'5px',fontSize : '16px'}"
            :offset="{width:0, height: -30}" />
        </bm-marker>
        <bm-circle :center="{lng: dutyd.baiduLng, lat: dutyd.baiduLat}" :radius="100" stroke-color="red" fillColor='red'
          :fillOpacity='0.3' :stroke-opacity="0.3" :stroke-weight="1"></bm-circle>

      </baidu-map>
    </el-dialog>
  </div>
</template>

<script>
  import {

    Ak
  } from '@/utils/config.js'
  import {
    addQRS,
    QRlist,
    delQR,
    upQR
  } from '@/api/patrol'
  import {
    BaiduMap,
    BmControl,
    BmView,
    BmMarker,
    BmCircle,
    BmLabel,
    BmInfoWindow,
    BmLocalSearch,
    BmAutoComplete
  } from 'vue-baidu-map'
  import QRCode from 'qrcodejs2'
  import {
    projectTotalHours
  } from '@/api/project'
  export default {
    name: 'CardPersonnelInfo',
    components: {
      BaiduMap,
      BmControl,
      BmView,
      BmMarker,
      BmCircle,
      BmInfoWindow,
      BmAutoComplete,
      BmLabel,
      BmLocalSearch,
      QRCode
    },
    props: {
      dataDesc: {
        type: Object,
        default: () => {
          return {}
        }
      },
      notData: {
        type: Boolean,
        default: true
      },
      currentType: {
        // 判断从哪里传递的
        type: String,
        default: ''
      }
    },
    data() {
      return {
        data: {},
        value: '',
        loading: false,
        hoursList: [], // 表示几个班次
        totalHours: '', // 总时长
        totalNum: '', // 总人数
        top:0,

        envhref: `${process.env.VUE_APP_UPLOAD_BASEURL_TRANSLATE}` + '/',
        zoom: 16,
        hrefs: '', // 下载地址
        Ak,
        keyword: '',
        circlePath: {
          center: {
            baiduLng: 116.404,
            baiduLat: 39.915
          },
          radius: 100
        },
        map: {
          width: '100%',
          height: '265px'
        },
        dutyd: {},
        isMapTab: false,
        isTableMap: false,

      }
    },
    created() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      this.value = year + '-' + month

      this.totalHours = this.dataDesc.totalHours
      this.totalNum = this.dataDesc.totalNum
      this.getListPost(this.dataDesc.post)
      if (this.dataDesc.hoursList) {
        this.gethoursList(this.dataDesc.hoursList)
      }
      this.id = this.$route.params.id
      // 可以先不调用
      // this._handleWorkDate();
    },
    mounted() {
      // this.$nextTick(() => {
      //   let el = this.$refs.elBodyW
      //   let wrapW = this.$refs.wrapW
      //   wrapW.style.width = el.scrollWidth + 500 + 'px'
      // })
    },
    filters: {
      // 截取字母
      getSubCode(val) {
        let name = val.substr(0, 1)
        return name
      },
      getWorkDay: function(value) {
        let val = value
        let arr = []
        if (!val) {
          return val
        }

        if (!Array.isArray(val)) {
          val = val.split(',')
        }
        val.forEach((week) => {
          if (week == 1) {
            week = '星期一'
          }
          if (week == 2) {
            week = '星期二'
          }
          if (week == 3) {
            week = '星期三'
          }
          if (week == 4) {
            week = '星期四'
          }
          if (week == 5) {
            week = '星期五'
          }
          if (week == 6) {
            week = '星期六'
          }
          if (week == 7) {
            week = '星期日'
          }
          arr.push(week)
        })
        return arr.join(',')
      }
    },
    methods: {
      // 获取岗位及工时处理
      getListPost(val) {
        if (val.length) {
          this.data = val.map((item) => {
            item.isShow = false
            item.ppc = item.ppc ? item.ppc : {}
            return item
          }).sort((a, b) => {
            return a.delState - b.delState
          })
          // .filter(item => {
          //   return item.delState !== 1
          // })
          // 计算从派遣单过来的总人数
          if (this.currentType === '派遣单') {
            let arr = this.data.map((item) => {
              return Number(item.num)
            })
            this.totalNum = arr.reduce((prev, curr) => {
              return prev + curr
            })
          }

          this.data.push({
            postName: '总人数',
            isTotal: true,
            num: this.totalNum,
            ppc: {},
            postTotalHours: this.totalHours
          })
        }
      },
      // 获取总工时
      gethoursList(val) {
        this.hoursList = val.map((item) => {
          let name = item.code.substr(0, 1)
          return {
            num: item.num,
            hous: item.hous,
            code: item.code,
            name: name
          }
        })
      },
      getPostType(postType) {
        switch (postType) {
          case 1:
            return '普通保安岗'
          case 2:
            return '形象岗'
          case 3:
            return '中控岗'
          case 4:
            return '班长岗'
          case 5:
            return '副队长岗'
          case 6:
            return '兼职队长岗'
          case 7:
            return '专职队长岗'
          default:
            return '普通保安岗'
        }
      },
      handleClickRote(item) {
        if (item.ppc && item.ppc.postName) {
          let index = this.data.indexOf(item)
          item.isShow = !item.isShow
          this.data.splice(index, 1, item)
        } else {
          this.$message.warning('没有班次配置')
        }
        // console.log(this.data);
      },
      // 获取工时状况
      getList() {
        let _self = this
        _self.loading = true
        let data = {
          id: this.id,
          date: this.value
        }
        projectTotalHours(data)
          .then((res) => {
            _self.loading = false
            _self.totalHours = res.data.totalHours
            _self.getListPost(res.data.post)
            _self.gethoursList(res.data.hoursList)
          })
          .catch((err) => {
            _self.loading = false
            console.log(err)
          })
      },
      handleDateValue(val) {
        this.getList()
      },
      _handleWorkDate() {
        if (!this.id) {
          return this.$message.warning('地址错误！')
        }

        this.getList()
      },





      //  地图初始化
      handler({
        BMap,
        map
      }) {
        this.$nextTick(() => {
          //   可以用来设置高宽
          // this.map.width = '100%'
          // this.map.height = '328px'
          this.zoom = 19
        })
      },
      xgmap(e) {
        // console.log(e.point)
        this.form.baiduLat = e.point.lat
        this.form.baiduLng = e.point.lng
        // console.log(this.form)
        let _self = this
        let geoc = new BMap.Geocoder()
        let pot = e.point
        geoc.getLocation(pot, function(rs) {
          // addressComponents对象可以获取到详细的地址信息
          var addComp = rs.addressComponents
          let province = addComp.province ? addComp.province : ''
          let city = addComp.city ? addComp.city : ''
          let district = addComp.district ? addComp.district : ''
          let street = addComp.street ? addComp.street : ''
          let streetNumber = addComp.streetNumber ? addComp.streetNumber : ''
          _self.form.site =
            province +
            city +
            district +
            street +
            streetNumber
        })
      },
      // 下载二维码
      downs(url) {
        let link = document.createElement('a')
        link.style.display = 'none'
        this.envhref = `${process.env.VUE_APP_UPLOAD_BASEURL_TRANSLATE}` + '/'
        link.href = `${process.env.VUE_APP_UPLOAD_BASEURL_TRANSLATE+'/'}${url}`
        link.setAttribute('download', '二维码.png')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link) // 下载完成移除元素
      },
      //列表地图位置
      tableMap(row) {
        // this.isMapTab = true
        var _that = this
        this.dutyd = row
        _that.isMapTab = true
        _that.isTableMap = true

      },

      mapOpen: function () {
          this.top = this.getScrollTop()
          if (this.top) {
              this.setScrollTop(0)
          }
      },
      mapClose: function () {
          this.setScrollTop(this.top);
          this.top = 0;
      },
      getScrollTop: function () {
          let scrollTop = 0;
          if (document.documentElement && document.documentElement.scrollTop) {
              scrollTop = document.documentElement.scrollTop;
          } else if (document.body) {
              scrollTop = document.body.scrollTop;
          }
          return scrollTop;
      },
      setScrollTop: function (top) {
          if (!isNaN(top)) {
              if (document.documentElement && document.documentElement.scrollTop !== undefined) {
                  document.documentElement.scrollTop = top;
              } else if (document.body) {
                  document.body.scrollTop = top;
              }
          }
      },



    }
  }
</script>

<style lang="scss" scoped>
  .head {
    font-weight: bold;
    color: #333;
    padding: 0 10px 10px;

    .team {
      font-weight: 400;
    }
  }

  .table_box {
    width: 100%;
    padding-bottom: 20px;

    .table_head {
      width: 100%;
      border-bottom: 1px solid #ebeef5;
      padding: 12px;
      line-height: 30px;
      display: flex;
      flex-wrap: nowrap;
      box-sizing: border-box;

      .table-th {
        color: #909399;
        font-weight: bold;
        min-width: 7%;
        padding-right: 1%;
        // box-sizing: border-box;
      }
    }

    .table-text {
      color: #909399;
      font-weight: bold;
    }

    .table_tbody {
      width: 100%;
      overflow: hidden;
      border-bottom: 1px solid #ebeef5;
      padding: 12px;
      display: flex;
      box-sizing: border-box;
      flex-wrap: nowrap;

      .table-tb {
        color: #333;
        min-width: 7%;
        padding-right: 1%;
        // box-sizing: border-box;
      }
    }

    .table_desc {
      cursor: pointer;

      i {
        transition: transform 0.2s ease-in-out;
      }
    }

    .table_desc.active {
      i {
        transform: rotate(180deg);
      }
    }

    .table_arrow_data {
      padding: 20px 12px;
      border-bottom: 1px solid #ebeef5;

      .table_arrow_list {
        .item {
          margin: 15px 0;
          height: auto;
          overflow: hidden;

          .name {
            font-size: #333;
          }
        }

        .item_flex {
          // max-width: 50%;
          margin: 5px 0;
          float: left;
        }

        .item_day {
          color: #999;
        }

        span {
          padding: 0 10px 0 0;
        }

        i {
          font-style: normal;
        }
      }
    }
  }

  .bc-title {
    // width: 56px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999;
    line-height: 40px;
  }

  .font_word,
  .footer_gs {
    font-weight: bold;
  }

  .not_bottom {
    border-bottom: 0 !important;
    margin-top: 10px;
  }

  @media screen and (max-width: 1920px) {
    .table_box {
      overflow-x: scroll;
    }

    .table_box .table_head .table-th {
      min-width: 98px;
    }

    .table_box .table_tbody .table-tb {
      min-width: 98px;
      padding-bottom: 20px;
      border-bottom: 1px solid #ebeef5;
    }

    .table_box .table_head .table-th {
      padding-bottom: 20px;
      border-bottom: 1px solid #ebeef5;
    }

    .table_box .table_head {
      border-bottom: none;
    }

    .table_box .table_arrow_data {
      border-bottom: none;
    }

    .table_box .table_tbody {
      overflow: initial;
      border-bottom: none;
    }
  }

  .post_name_table_box {
    .table_tbody {
      overflow: initial;
    }
  }
</style>
<style lang="scss">
  .tableMap {
    .el-dialog__body {
      padding: 10px 20px;
    }
  }
</style>
